import { Provider } from "react-redux";
import Footer from "./components/Footer";
import Search from "./components/Search";
import Navbar from "./components/Navbar";
import store from "./redux/store/store";
import { BlogList } from "./components/BlogList";
import {
    BrowserRouter,
    Routes,
    Route,
  } from "react-router-dom";

function App() {
    return (
        <Provider store={store}>
        <BrowserRouter>
        <Routes>
            <Route path="/" element={
                <>
                <Navbar />
                <Search />
                <BlogList/>
                <Footer />
                </>
            }/>
        </Routes>
        </BrowserRouter>
        </Provider>
    );
}

export default App;
